import type { TRuleWithTheme } from 'styles/theme';
import type { ElevatorSubStateName } from 'modules/entities/modules/elevators';

import { IconType } from 'modules/ui';

export const container: TRuleWithTheme<{ name: ElevatorSubStateName; type: IconType }> = ({ theme, type }) => ({
    color: type === IconType.TECHNICIAN_ON_SITE ? theme.colors.statusInfo : theme.colors.icon,
});
